module.exports = __webpack_public_path__ + "static/media/SwagingMachinesforRailwaycablesdesktop.0f0b9278.jpg";